import { render, staticRenderFns } from "./LoanRequests.vue?vue&type=template&id=4a7bdfd7&"
import script from "./LoanRequests.vue?vue&type=script&lang=js&"
export * from "./LoanRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports